<template>
    <div class="question">

        <div class="question__actions">
            <ul>
                <li><i class="fas fa-arrows-alt-v"></i></li>
                <li v-on:click="editQuestion"><i class="fas fa-edit"></i></li>
                <li v-on:click="deleteQuestion"><i class="fas fa-trash-alt"></i></li>
            </ul>
        </div>
        <div>
            <a href="#">
                <div v-on:click="addQuestion(false)" class="question__add section__add--top">+</div>
            </a>
        </div>
        <div>
            <a href="#">
                <div v-on:click="addQuestion(true)" class="question__add section__add--bottom">+</div>
            </a>
        </div>

        <div v-if="deleting || error" class="infobar" v-bind:class="{'infobar-info' : deleting, 'infobar-error' : error}">
            {{infoMessage}}
        </div>

        <template v-if="!deleted">
            <QuestionPreview v-bind:question="question" v-bind:askingPersonalInformation="askingPersonalInformation"></QuestionPreview>
            <div v-if="editing">
                <EditQuestion v-bind:formTemplateReference="formTemplateReference"
                              v-bind:formSectionReference="formSectionReference"
                              v-bind:askingPersonalInformation="askingPersonalInformation"
                              v-bind:question="question"
                              v-bind:index="index"></EditQuestion>
            </div>
        </template>
    </div>

</template>

<script>
    import { store } from '../../store.js'
    import EditQuestion from './EditQuestion'
    import QuestionPreview from './QuestionPreview'

    export default {
        name: 'FormQuestionTemplate',
        components: {
            EditQuestion, QuestionPreview
        },
        // components: { Spinner, ValidationProvider },
        props: {
            formTemplateReference: String,
            formSectionReference: String,
            askingPersonalInformation: Boolean,
            question: Object,
            index: Number
        },
        data: function () {
            return {
                editing: false,
                deleting: false,
                deleted: false,
                error: false,
                infoMessage: "Deleting question"
            }
        },
        methods: {
            scrollToTopOfQuestion: function () {
                const rect = this.$el.getBoundingClientRect();
                window.scrollTo(rect.x, window.pageYOffset + rect.top - 5)
            },
            editQuestion: function() {
                console.log('edit');
                this.editing = true;
                this.$root.$emit('editing-section-or-question');
                console.log('showing edit modal');
            },
            stopEditing: function() {
                this.editing = false;
            },
            checkIfEditingThisQuestion: function(formSectionReference, index) {
                if (this.formSectionReference === formSectionReference && this.index === index) {
                    console.log("Opening dialog to edit new question");
                    this.editing = true;
                    this.$root.$emit('editing-section-or-question');
                    this.scrollToTopOfQuestion();
                }
            },
            deleteQuestion: function() {
                console.log("Deleting question");
                this.deleting = true;
                this.infoMessage = "Deleting question";
                this.$http.delete('/guest-management/v1/establishments/' + store.currentEstablishmentReference
                    + '/form-templates/' + this.formTemplateReference
                    + "/question-templates/" + this.question.reference
                ).then(response => {
                    console.log("Question deleted:")
                    console.log(response);
                    this.infoMessage = "Question successfully deleted";
                    this.deleted = true;
                    setTimeout(() => {
                        this.deleting = false;
                        this.$root.$emit('delete-question-from-section', this.formSectionReference, this.index);
                    }, 2000);
                }).catch(error => {
                    this.deleting = false;
                    this.error = true;
                    if (error.response) {
                        this.infoMessage = "Error: " + error.response.data.message;
                    } else {
                        this.infoMessage = "Error deleting question";
                    }
                    setTimeout(() => {
                        this.error = false;
                    }, 5000);
                });
            },
            addQuestion: function (after) {
                console.log("Adding question");
                let addIndex = this.index;
                if (after) {
                    addIndex = addIndex + 1;
                }
                this.$root.$emit('add-question-to-section', this.formSectionReference, addIndex);
            }
        },
        mounted() {
            this.$root.$on('edit-new-question', this.checkIfEditingThisQuestion);
            this.$root.$on('finished-editing-section-or-question', this.stopEditing);
        },
        beforeDestroy() {
            this.$root.$off('edit-new-question', this.checkIfEditingThisQuestion);
            this.$root.$off('finished-editing-section-or-question', this.stopEditing);
        },
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/components/question_answer";
    @import "../../styles/pages/edit-form";
</style>
